export const faqItems = [
  {
    q: "Was ist Wagenhofer Capital?",
    a: "Wagenhofer Capital ist eine unternehmerische Beteiligungs- und Verwaltungsgesellschaft mit Sitz im Raum München. Wir bündeln Beteiligungen, operative Projekte und Unternehmen unter einer klaren Dachstruktur – mit Fokus auf nachhaltigem Wachstum, professioneller Führung und langfristiger Wertschöpfung.",
  },
  {
    q: "In welche Sektoren investiert Wagenhofer Capital?",
    a: "Unser Investmentfokus umfasst Unternehmensbeteiligungen, Gastronomie, Immobilien, Events & Entertainment, Dienstleistungen sowie zukunftsorientierte Geschäftsmodelle mit klarer wirtschaftlicher Substanz.",
  },
  {
    q: "Welche Region steht im Fokus?",
    a: "Unser Heimatmarkt ist der Großraum München und Bayern. Wir prüfen darüber hinaus selektive Opportunitäten im gesamten deutschsprachigen Raum.",
  },
  {
    q: "Welche Unternehmensgrößen sind relevant?",
    a: "Wir konzentrieren uns auf mittelständische Unternehmen, Familienunternehmen, etablierte Mittelstandsbetriebe sowie operative Projekt- und Standortgesellschaften. Klassische Anlagevehikel, Fondsstrukturen oder rein finanzielle Beteiligungen ohne unternehmerische Substanz sind nicht Teil unseres Fokus.",
  },
  {
    q: "Wie läuft eine Beteiligung typischerweise ab?",
    a: "Der Prozess umfasst Erstgespräch, strategische Analyse, Due Diligence, vertragliche Strukturierung, gemeinsame Umsetzung und langfristige Partnerschaft. Wir arbeiten diskret, strukturiert und mit klarer zeitlicher Taktung.",
  },
  {
    q: "Welche Rolle übernimmt Wagenhofer Capital nach der Beteiligung?",
    a: "Wir verstehen uns als aktiver, unternehmerischer Partner. Je nach Situation begleiten wir Strategie, Governance, Finanzen, operative Strukturen und die langfristige Weiterentwicklung – immer abgestimmt mit dem Management und den Eigentümern.",
  },
  {
    q: "Ist Wagenhofer Capital ein klassischer Private-Equity-Investor?",
    a: "Nein. Wir verfolgen einen unternehmerischen Beteiligungsansatz mit langfristiger Perspektive – nicht renditegetriebene Fondsmodelle mit fester Laufzeit. Substanz, Verantwortung und nachhaltige Entwicklung stehen vor schnellen Exit-Strategien.",
  },
  {
    q: "Bietet Wagenhofer Capital Anlageberatung oder Vermögensverwaltung an?",
    a: "Nein. Wagenhofer Capital erbringt ausdrücklich keine Anlageberatung, Finanzportfolioverwaltung oder Finanzdienstleistungen gegenüber Dritten. Diese Website dient ausschließlich der allgemeinen Unternehmensdarstellung und stellt kein öffentliches Angebot zum Erwerb von Beteiligungen oder Kapitalanlagen dar.",
  },
  {
    q: "Wie kann ich ein Projekt oder Unternehmen vorstellen?",
    a: "Über das Kontaktformular oder per E-Mail an muenchen@wagenhofer.capital. Wir prüfen jede Anfrage diskret und antworten in der Regel innerhalb weniger Werktage.",
  },
  {
    q: "Wie wird mit vertraulichen Informationen umgegangen?",
    a: "Diskretion ist Teil unseres Selbstverständnisses. Alle übermittelten Informationen werden vertraulich behandelt; bei tiefergehenden Gesprächen schließen wir auf Wunsch eine gegenseitige Vertraulichkeitsvereinbarung (NDA).",
  },
  {
    q: "In welchem Zeitrahmen erfolgt eine Entscheidung über eine Beteiligung?",
    a: "Nach Erstgespräch und Unterlagenprüfung geben wir in der Regel binnen weniger Wochen eine indikative Rückmeldung. Der weitere Prozess hängt von Komplexität, Branche und Transaktionsstruktur ab.",
  },
  {
    q: "Welche Anforderungen stellt Wagenhofer Capital an Partner?",
    a: "Wir suchen Unternehmer, Inhaber und Führungspersönlichkeiten mit klarer Haltung, unternehmerischer Substanz und langfristiger Perspektive. Verlässlichkeit, Transparenz und partnerschaftliches Handeln sind Voraussetzung.",
  },
  {
    q: "Werden auch Immobilienprojekte geprüft?",
    a: "Ja. Wir prüfen Standorte, Nutzungskonzepte, Betreiberstrukturen und langfristige Entwicklungspotenziale – insbesondere mit Fokus auf Gastronomie, gewerbliche Nutzung und urbane Lagen im Raum München.",
  },
  {
    q: "Ist Wagenhofer Capital für Unternehmensnachfolgen ein Ansprechpartner?",
    a: "Ja. Unternehmensnachfolgen sind ein zentrales Thema. Wir bieten Inhabern, die ihr Lebenswerk in verantwortungsvolle Hände übergeben möchten, eine langfristig orientierte und unternehmerisch geprägte Lösung.",
  },
  {
    q: "Gibt es eine öffentliche Liste der Beteiligungen?",
    a: "Nein. Beteiligungen und Projekte werden grundsätzlich diskret gehalten und nicht öffentlich kommuniziert. Im Rahmen eines konkreten Gesprächs geben wir relevanten Partnern individuell Einblick.",
  },
];
